import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";
import fonts from "./fonts";
import commonSettings, { handleBackdropFilter } from "./global.js";

const lightTheme = {
  color: "#253449",
  gold: "#F8CC82",
  gray: "#A3A3A3",
  blueish_gray: "#768299",
  textHighlightColor: "#93AEBC", // "#F4D092",
  backgroundColor: "#AFCDE9",
  // background:
  // "radial-gradient(circle at 25% 0%, rgba(227,255,240,.5), rgba(227,255,240,0) 50%), radial-gradient(circle at 80% 80%, rgba(131,165,203,.5), rgba(131,165,203,0) 50%)",
  background: "linear-gradient(112.49deg, #F5F8F7 12.51%, #F9FFFD 97.2%)",
  paperBg: "linear-gradient(184.2deg, rgba(245, 245, 245, 0.8) 0.12%, #FFFFFF 100%);",
  paperBgColor: "linear-gradient(184.2deg, rgba(245, 245, 245, 0.8) 0.12%, #FFFFFF 100%);",
  modalBg: "#FAFAFAEF",
  popoverBg: "rgba(255, 255, 255, 0.95)",
  menuBg: handleBackdropFilter("rgba(255, 255, 255, 0.5)"),
  backdropBg: "rgba(200, 200, 200, 0.4)",
  largeTextColor: "#759AAE",
  activeLinkColor: "#222222",
  activeLinkSvgColor: "invert(64%) sepia(11%) saturate(934%) hue-rotate(157deg) brightness(90%) contrast(86%)",
  // primaryButtonBG: "#759AAE",
  primaryButtonBG: "#93AEBC",
  // primaryButtonBG: "rgba(0,166,100,1)",
  primaryButtonHoverBG: "#759AAE",
  // these need fixing
  primaryButtonHoverColor: "#fff",
  // primaryButtonHoverColor: "#F8CC82",
  secondaryButtonHoverBG: "rgba(54, 56, 64, 1)",
  secondaryButtonBG: "#181A1D",
  outlinedPrimaryButtonHoverBG: "#F8CC82",
  // outlinedPrimaryButtonHoverColor: "#333333",
  outlinedPrimaryButtonHoverColor: "#F8CC82",
  outlinedSecondaryButtonHoverBG: "#FCFCFC",
  outlinedSecondaryButtonHoverColor: "#333333",
  containedSecondaryButtonHoverBG: "#33333333",
  graphStrokeColor: "rgba(37, 52, 73, .2)",
  idoBorder: "rgba(0, 0, 0, 0.12)",
  idoGridBorder: "rgba(0, 8, 9, 0.3)",
};

export const light = responsiveFontSizes(
  createTheme(
    {
      primary: {
        main: lightTheme.color,
      },
      palette: {
        type: "light",
        background: {
          default: lightTheme.backgroundColor,
          paper: lightTheme.paperBg,
        },
        contrastText: lightTheme.color,
        primary: {
          main: lightTheme.color,
        },
        neutral: {
          main: lightTheme.color,
          secondary: lightTheme.gray,
        },
        text: {
          primary: lightTheme.color,
          secondary: lightTheme.blueish_gray,
        },
        graphStrokeColor: lightTheme.graphStrokeColor,
      },
      typography: {
        fontFamily: "Square",
      },
      props: {
        MuiSvgIcon: {
          htmlColor: lightTheme.color,
        },
      },
      overrides: {
        MuiCssBaseline: {
          "@global": {
            "@font-face": fonts,
            body: {
              background: lightTheme.background,
            },
          },
        },
        MuiPaper: {
          root: {
            backgroundColor: "#FEFEFE",
            "&.ohm-card": {
              background: "#FEFEFE",
            },
            "&.ohm-modal": {
              backgroundColor: lightTheme.modalBg,
            },
            "&.ohm-menu": {
              backgroundColor: lightTheme.menuBg,
              backdropFilter: "blur(33px)",
            },
            "&.ohm-popover": {
              backgroundColor: lightTheme.popoverBg,
              color: lightTheme.color,
              backdropFilter: "blur(15px)",
            },
            "&.ido-card": {
              backgroundColor: lightTheme.paperBgColor,
              background: lightTheme.paperBgColor,
            },
            "&.ido-card-infos": {
              backgroundColor: lightTheme.paperBgColor,
              background: lightTheme.paperBgColor,
            },
            "&.ido-card-desc": {
              backgroundColor: lightTheme.paperBgColor,
              background: lightTheme.paperBgColor,
            },
          },
        },
        MuiDrawer: {
          paper: {
            backgroundColor: lightTheme.paperBg,
            background: lightTheme.paperBg,
            zIndex: 7,
          },
        },
        MuiBackdrop: {
          root: {
            backgroundColor: "rgba(255,255,255, 0)",
          },
        },
        MuiLink: {
          root: {
            color: lightTheme.color,
            "&:hover": {
              // color: lightTheme.primaryButtonBG,
              backgroundColor: "#E0E2E3",
              textDecoration: "none",
              "&.active": {
                // color: lightTheme.color,
              },
            },
            "&.active": {
              color: lightTheme.color,
              textDecoration: "underline",
            },
            "@media (hover:none)": {
              "&:hover": {
                color: lightTheme.primaryButtonBG,
                textDecoration: "none",
                backgroundColor: "#00000000 !important",
              },
              "&:focus": {
                color: lightTheme.primaryButtonBG,
                backgroundColor: "#00000000 !important",
              },
            },
            "&.ido": {
              borderBottom: `1px solid ${lightTheme.idoBorder}`,
              borderTop: `1px solid ${lightTheme.idoBorder}`,
            },
          },
        },
        MuiTableCell: {
          root: {
            color: lightTheme.color,
          },
        },
        MuiInputBase: {
          root: {
            color: lightTheme.color,
          },
        },
        MuiOutlinedInput: {
          notchedOutline: {
            borderColor: `${lightTheme.color} !important`,
            "&:hover": {
              borderColor: `${lightTheme.color} !important`,
            },
          },
        },
        MuiTab: {
          textColorPrimary: {
            color: "#a3a3a3",
            "&$selected": {
              color: lightTheme.primaryButtonBG,
            },
          },
          textColorSecondary: {
            color: "#676B74",
            "&$selected": {
              color: lightTheme.secondaryButtonBG,
            },
          },
        },
        PrivateTabIndicator: {
          colorPrimary: {
            backgroundColor: lightTheme.primaryButtonBG,
          },
          colorSecondary: {
            backgroundColor: lightTheme.secondaryButtonBG,
          },
        },
        MuiToggleButton: {
          root: {
            background: lightTheme.paperBgColor,
            "&:hover": {
              color: lightTheme.color,
              backgroundColor: lightTheme.containedSecondaryButtonHoverBG,
            },
            selected: {
              backgroundColor: lightTheme.containedSecondaryButtonHoverBG,
            },
            "@media (hover:none)": {
              "&:hover": {
                color: lightTheme.color,
                backgroundColor: lightTheme.paperBgColor,
              },
              "&:focus": {
                color: lightTheme.color,
                background: lightTheme.paperBgColor,
              },
            },
          },
        },
        MuiIconButton: {
          root: {
            "&:hover": {
              backgroundColor: lightTheme.containedSecondaryButtonHoverBG,
            },
            "@media (hover:none)": {
              "&:hover": {
                color: lightTheme.color,
                backgroundColor: lightTheme.containedSecondaryButtonHoverBG,
              },
              "&:focus": {
                color: lightTheme.color,
                backgroundColor: lightTheme.containedSecondaryButtonHoverBG,
              },
            },
          },
        },
        MuiButton: {
          containedPrimary: {
            color: "#fff",
            backgroundColor: lightTheme.primaryButtonBG,
            "&:hover": {
              backgroundColor: lightTheme.primaryButtonHoverBG,
              color: lightTheme.primaryButtonHoverColor,
            },
            "@media (hover:none)": {
              color: lightTheme.color,
              backgroundColor: lightTheme.primaryButtonBG,
              "&:hover": {
                backgroundColor: lightTheme.primaryButtonHoverBG,
              },
            },
          },
          containedSecondary: {
            color: lightTheme.color,
            background: lightTheme.paperBgColor,
            backgroundColor: lightTheme.paperBgColor,
            "&:hover": {
              color: "#000",
              backgroundColor: `${lightTheme.containedSecondaryButtonHoverBG}`,
            },
            "@media (hover:none)": {
              color: lightTheme.color,
              background: lightTheme.paperBgColor,
              "&:hover": {
                color: "#FCFCFC",
                backgroundColor: `${lightTheme.containedSecondaryButtonHoverBG} !important`,
              },
            },
          },
          outlinedPrimary: {
            color: lightTheme.primaryButtonBG,
            borderColor: lightTheme.primaryButtonBG,
            "&:hover": {
              color: lightTheme.outlinedPrimaryButtonHoverBG,
              backgroundColor: lightTheme.primaryButtonHoverBG,
              borderColor: lightTheme.primaryButtonBG,
            },
            "@media (hover:none)": {
              color: lightTheme.primaryButtonBG,
              borderColor: lightTheme.primaryButtonBG,
              "&:hover": {
                color: `${lightTheme.outlinedPrimaryButtonHoverBG} !important`,
                backgroundColor: `${lightTheme.primaryButtonBG} !important`,
              },
            },
          },
          outlinedSecondary: {
            color: lightTheme.color,
            borderColor: lightTheme.color,
            "&:hover": {
              color: lightTheme.outlinedSecondaryButtonHoverColor,
              backgroundColor: lightTheme.outlinedSecondaryButtonHoverBG,
              borderColor: "#333333",
            },
          },
          textPrimary: {
            color: lightTheme.gray,
            "&:hover": {
              color: lightTheme.textHighlightColor,
              backgroundColor: "#00000000",
            },
            "&:active": {
              color: lightTheme.gold,
              borderBottom: "#F8CC82",
            },
          },
          textSecondary: {
            color: lightTheme.color,
            "&:hover": {
              color: lightTheme.textHighlightColor,
            },
          },
        },
        MuiGrid: {
          root: {
            "&.ido-grid": {
              border: `1px solid ${lightTheme.idoGridBorder}`,
            },
            "&.ido-grid-btn": {
              // border: `1px solid ${lightTheme.idoGridBorder}`,
              padding: `0 !important`,
            },
          },
        },
        MuiTypography: {
          root: {
            "&.ido-typography": {
              // color: "red",
              textShadow: "#000 0 0 10px",
            },
          },
        },
      },
    },
    commonSettings,
  ),
);
